var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1291 15.72C13.1291 16.3441 12.6232 16.85 11.9991 16.85C11.3751 16.85 10.8691 16.3441 10.8691 15.72C10.8691 15.0959 11.3751 14.59 11.9991 14.59C12.6232 14.59 13.1291 15.0959 13.1291 15.72Z",
    fill: "url(#paint0_linear_720_4261)",
    stroke: "url(#paint1_linear_720_4261)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.28 9.53V8.28C18.28 5.58 17.63 2 12 2C6.37 2 5.72 5.58 5.72 8.28V9.53C2.92 9.88 2 11.3 2 14.79V16.65C2 20.75 3.25 22 7.35 22H16.65C20.75 22 22 20.75 22 16.65V14.79C22 11.3 21.08 9.88 18.28 9.53ZM12 18.74C10.33 18.74 8.98 17.38 8.98 15.72C8.98 14.05 10.34 12.7 12 12.7C13.66 12.7 15.02 14.06 15.02 15.72C15.02 17.39 13.67 18.74 12 18.74ZM7.35 9.44C7.27 9.44 7.2 9.44 7.12 9.44V8.28C7.12 5.35 7.95 3.4 12 3.4C16.05 3.4 16.88 5.35 16.88 8.28V9.45C16.8 9.45 16.73 9.45 16.65 9.45H7.35V9.44Z",
    fill: "url(#paint2_linear_720_4261)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_720_4261",
    x1: 10.3691,
    y1: 14.09,
    x2: 13.6599,
    y2: 17.0882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59DC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6F4A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_720_4261",
    x1: 10.3691,
    y1: 14.09,
    x2: 13.6599,
    y2: 17.0882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59DC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6F4A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_720_4261",
    x1: 2,
    y1: 2,
    x2: 22.189,
    y2: 20.3936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59DC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6F4A9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.9e5c0e3051998e70c08767dabfb58d62.svg";
export { ForwardRef as ReactComponent };